import { render, staticRenderFns } from "./ImageResize.vue?vue&type=template&id=1c5af4d8&scoped=true&"
import script from "./ImageResize.vue?vue&type=script&lang=js&"
export * from "./ImageResize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5af4d8",
  null
  
)

export default component.exports